module.exports = __webpack_public_path__ + "img/VirtualCapabilities_00276.91b1f59b.jpg";